export default __webpack_public_path__ + "static/media/3_bucketOfGems.49260282.png";